import { render } from "./ProjectUsers.vue?vue&type=template&id=3038adc7"
import script from "./ProjectUsers.vue?vue&type=script&lang=js"
export * from "./ProjectUsers.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__